var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 576,
    height: 576
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 342.9495,
    width: 62.2222,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 325.9797,
    width: 62.2222,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7777,
    y: 309.01,
    width: 26.6667,
    height: 8.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7777,
    y: 292.0404,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7777,
    y: 275.0706,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7777,
    y: 258.101,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 241.1313,
    width: 62.2222,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224.1617,
    width: 62.2222,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1112,334.8686h94.842a33.7121,33.7121,0,0,0,3.576-8.8889h-98.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5286,292.04h-69.64v8.8888h77.0547A34.0754,34.0754,0,0,0,286.5286,292.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8889,275.0706V283.96h69.64a34.0774,34.0774,0,0,0,7.415-8.8889Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9532,241.1313h-94.842V250.02h98.418A33.7148,33.7148,0,0,0,293.9532,241.1313Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5656,224.1617H199.1112v8.8888h88.35A33.8138,33.8138,0,0,0,264.5656,224.1617Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.8889,
    y: 258.101,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6061,266.99h28.71a33.9492,33.9492,0,0,0,1.189-8.8889h-29.899Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.8889,
    y: 309.01,
    width: 26.6667,
    height: 8.889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6061,309.01v8.889h29.899a33.9488,33.9488,0,0,0-1.189-8.889Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1112,351.75l65.4544.0879a33.6926,33.6926,0,0,0,22.8959-8.8888h-88.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.875 351.838 379.979 342.949 373.799 342.949 376.875 351.838"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.962 334.869 382.816 334.869 385.936 325.98 367.842 325.98 370.962 334.869"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.005 317.899 388.773 317.899 391.894 309.01 361.884 309.01 365.005 317.899"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.047 300.929 394.731 300.929 397.851 292.04 355.927 292.04 359.047 300.929"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.556 266.99 371.58 266.99 368.489 258.101 323.556 258.101 323.556 266.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.099 250.02 448 250.02 448 241.131 391.19 241.131 388.099 250.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.091 224.162 394 233.051 448 233.051 448 224.162 397.091 224.162"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.7779,
    y: 342.9495,
    width: 44.4445,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.7779,
    y: 325.9797,
    width: 44.4445,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5556,
    y: 309.01,
    width: 26.6667,
    height: 8.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5556,
    y: 292.0404,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.222 258.101 385.289 258.101 382.198 266.99 430.222 266.99 430.222 258.101"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.556 283.96 430.222 283.96 430.222 275.071 403.556 275.071 403.556 275.071 379.387 275.071 376.889 282.256 374.39 275.071 350.222 275.071 323.556 275.071 323.556 283.96 350.222 283.96 350.222 275.791 353.09 283.96 400.688 283.96 403.556 275.792 403.556 283.96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.5555,
    y: 292.0404,
    width: 26.6667,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.5555,
    y: 309.01,
    width: 26.6667,
    height: 8.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.5555,
    y: 325.9797,
    width: 44.4445,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.5555,
    y: 342.9495,
    width: 44.4445,
    height: 8.8889
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.679 250.02 362.588 241.131 305.778 241.131 305.778 250.02 365.679 250.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.778 233.051 356.687 224.162 305.778 224.162 305.778 233.051 359.778 233.051"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/ibm.2de882e4b2fa9c34cdb8586b83ee7adc.svg";
export { ForwardRef as ReactComponent };